import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';

import { GoogleBusinessProfileFirstConnectionComponent } from './google-business-profile-first-connection/google-business-profile-first-connection.component';
import { GoogleBusinessProfileLoginComponent } from './google-business-profile-login/google-business-profile-login.component';
import { GoogleBusinessProfileService } from './google-business-profile.service';

downgradedAngularModule
  .directive('angularGoogleBusinessProfileFirstConnection', downgradeComponent({ component: GoogleBusinessProfileFirstConnectionComponent }))
  .directive('angularGoogleBusinessProfileLogin', downgradeComponent({ component: GoogleBusinessProfileLoginComponent }))
  .factory('AngularGoogleBusinessProfileService', downgradeInjectable(GoogleBusinessProfileService))
  ;

